import axios from 'axios'
import { errorHandler } from "../exports/error_management"
import { StorageCache } from '../exports/dataStorage'

const storageKey = 'ams-request-category-key'
const api = async (method, path, params) => axios[method](path, params)

const state = {
    category: {},
    categories: [],
}

const mutations = {
    set_category(state, payload) {
        state.category = payload
    },
    set_categories(state, payload) {
        state.categories = payload
    },
}

const actions = {
    async create(context, payload) {
        new StorageCache(storageKey).reset()
        try {
            const results = await api('post', `request-category`, payload)
            context.commit('set_category', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, id) {
        try {
            const results = await api('get', `request-category/${id}`)
            context.commit('set_category', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(context) {
        const storageCache = new StorageCache(storageKey)

        try {
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const results = await api('get', `request-category`)
                const data = results.data.success.data
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            context.commit('set_categories', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    async updateRequestCategoryOrder(context, payload) {
        new StorageCache(storageKey).reset()
        try {
            await api(
                'post',
                `request-category/update/display/order/`,
                payload
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async update(context, payload) {
        console.log('update', payload)
        new StorageCache(storageKey).reset()
        try {
            const results = await api(
                'put',
                `request-category/${payload.id}`,
                payload
            )
            context.commit('set_category', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        new StorageCache(storageKey).reset()
        try {
            await api('delete', `request-category/${id}`)
            context.commit('set_category', null)
            context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}